import { SettingsPermissions } from "@redotech/account-common/permissions";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { IntegrationsHubRedirect } from "../integrations-hub-redirect";

export const orderTrackingSettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      breadcrumb: "General",
      permission: SettingsPermissions.SET_MARKETING_SETTINGS,
    },
    path: "order-tracking",
    lazy: async () => {
      const { OrderTrackingSettings } =
        await import("../../../../setting/order-tracking/order-tracking-settings");
      return { Component: OrderTrackingSettings };
    },
  },
  {
    handle: {
      breadcrumb: "Integrations",
      permission: SettingsPermissions.SET_MARKETING_SETTINGS,
    },
    path: "order-tracking-integrations",
    element: <IntegrationsHubRedirect to="../integrations" />,
  },
];
